/** @namespace */
var Tremol = Tremol || {};
Tremol.FP = Tremol.FP ||
    /** 
     * Tremol fiscal printer javascript library. Usage: var fp = new Tremol.FP();
     * @constructor
     * @class FP
     * @classdesc Tremol fiscal printer javascript library.
     * @memberof Tremol
     * @instance
     */
    function (clientId) {
        if (!(this instanceof Tremol.FP)) {
            return new Tremol.FP(clientId);
        }
        this.prototype = this;
        var client = clientId;
        var coreVersion = "1.0.1.1";
        var ip = "localhost";
        var port = 4444;
        var url = "http://localhost:4444/";
        var defsSent = false;
        var w = false;
        var ok = false;

        var psr = (typeof DOMParser !== 'undefined' ? new DOMParser() : function () { throw new Error(); });
        var req = (typeof XMLHttpRequest !== 'undefined' ? new XMLHttpRequest() : function () { throw new Error(); });
        try { req.withCredentials = false; } catch (ignored) { /** ignored */ }
        try { req.overrideMimeType("text/xml; charset=UTF-8"); } catch (ignored) {  /** ignored */ }

        var sendReq = async function (verb, address, data) {
            w = true;
            var resp = null;
            var err = null;
            await new Promise(function (resolve, reject) {
                try {
                    req.open(verb, address + (client ? "?client=" + client : ""), true);
                    // req.setRequestHeader("Access-Control-Request-Private-Network", "true");
                    req.setRequestHeader("Content-Type", "text/plain");
                    req.onreadystatechange = function () {
                        if (this.readyState == 4) {
                            try {
                                if (req.status !== 200) {
                                    reject(new Error("HTTP code " + req.status));
                                } else {
                                    var respXml = psr.parseFromString(req.response, "text/xml");
                                    throwOnServerError(respXml);
                                    resolve(respXml);
                                }
                            }
                            catch (ex) {
                                if (ex instanceof Tremol.ServerError) {
                                    reject(ex);
                                }
                                else {
                                    reject(new Tremol.ServerError("Server connection error (" + ex.message + ")", Tremol.ServerErrorType.ServerConnectionError));
                                }
                            }
                        }
                    };
                    req.send(data);
                }
                catch (ex) {
                    if (ex instanceof Tremol.ServerError) {
                        reject(ex);
                    }
                    else {
                        reject(new Tremol.ServerError("Server connection error (" + ex.message + ")", Tremol.ServerErrorType.ServerConnectionError));
                    }
                }
            }).then(function fnOk(respOK) {
                resp = respOK;
            }).catch(function fnErr(respErr) {
                err = respErr;
            });
            if (err) throw err;
            return resp;
        };

        var throwOnServerError = function (resp) {
            var resRoot = resp.getElementsByTagName("Res")[0];
            var resCode = Number(resRoot.getAttribute("Code"));
            if (resCode !== 0) {
                var errNode = resp.getElementsByTagName("Err")[0];
                /** var source = errNode.getAttribute("Source"); */
                var errMsg = resp.getElementsByTagName("Message")[0].firstChild.data;
                if (resCode === 40) {
                    var ste1 = parseInt(errNode.getAttribute("STE1"), 16);
                    var ste2 = parseInt(errNode.getAttribute("STE2"), 16);
                    var fpliberror = parseInt(errNode.getAttribute("FPLibErrorCode"), 16);
                    throw new Tremol.ServerError(errMsg, resCode, ste1, ste2, fpliberror);
                }
                else {
                    throw new Tremol.ServerError(errMsg, resCode);
                }
            }
        }

        /**
         * 
         * @param {Document} resp 
         * @returns 
         */
        var analyzeResponse = function (resp) {
            resp.getlementby
            var resRoot = resp.getElementsByTagName("Res")[0];
            var props = resRoot.getElementsByTagName("Res");
            var resultObj = {};
            var name = "";
            var p = 0;
            for (; p < props.length; p++) {
                var prop = props[p];
                var type = prop.getAttribute("Type");
                name = prop.getAttribute("Name");
                var value = prop.getAttribute("Value");
                if (value === "@") {
                    resultObj[name] = null;
                    break;
                }
                if (name === "Reserve") {
                    continue; /** SKIP */
                }
                switch (type) {
                    case "Text":
                        resultObj[name] = value;
                        break;
                    case "Number":
                        resultObj[name] = parseFloat(value);
                        break;
                    case "Decimal":
                        resultObj[name] = parseFloat(value);
                        break;
                    case "Option":
                        resultObj[name] = value;
                        break;
                    case "DateTime":
                        resultObj[name] = value.parseDateWithFormat(Date.TremolFpFormat);
                        break;
                    case "Reserve":
                    case "OptionHardcoded":
                        continue; /** SKIP */
                    case "Base64":
                        resultObj[name] = String(value).base64stringToArrayBuffer();
                        break;
                    case "Decimal_with_format":
                        resultObj[name] = parseFloat(value);
                        break;
                    case "Decimal_plus_80h":
                        resultObj[name] = parseFloat(value);
                        break;
                    case "Status":
                        resultObj[name] = (value === "1")
                        break;
                    case "Null":
                        resultObj[name] = null;
                        break;
                    default: /** unknown type => string */
                        resultObj[name] = value;
                        break;
                }
            }
            if (p === 1) {
                return resultObj[name];
            }
            else {
                return resultObj;
            }
        };

        /**
         * Returns the version of the core library
         * @returns {string}
         */
        this.GetVersionCore = async function () {
            return coreVersion;
        };

        /**
         * Returns the version of the generated library
         * @returns {number}
         */
        this.GetVersionDefinitions = async function () {
            if (this.prototype.timeStamp) {
                return this.prototype.timeStamp;
            }
            else {
                return 0;
            }
        };

        /**
         * Returns true if there is a command which is currently in progress 
         * @returns {boolean}
         */
        this.IsWorking = async function () {
            return w;
        };

        /** 
         * Returns true if server definitions and generated code are with the same versions 
         * @returns {boolean}
         */
        this.IsCompatible = async function () {
            return ok;
        };

        /**
         * Sends command to ZfpLab server
         * @param {string} commandName The name of the command
         * @param {...*} var_args Command arguments(ArgumentName, ArgumentValue, ArgumentName2, ArgumentValue2)
         * @return {*} 
         * @throws {Error}
         */
        this.do = async function (commandName) {
            try {
                if (arguments.length < 1) {
                    throw new Error("Invalid number of arguments!");
                }
                if ((arguments.length % 2) === 0) {
                    throw new Error("Invalid number of arguments!");
                }

                /** var xml = psr.parseFromString("<Command></Command>", "text/xml");
                var rt = xml.getElementsByTagName("Command")[0];
                rt.setAttribute("Name", commandName);
                if(arguments.length > 1)
                {
                    var as = xml.createElement("Args");
                    rt.appendChild(as);
                    for (var a = 1; a < arguments.length; a+=2) 
                    {
                        var an = xml.createElement("Arg");
                        an.setAttribute("Name", arguments[a]);
                        if(typeof arguments[a + 1]  === "string")
                        {
                            an.setAttribute("Value", arguments[a + 1].escapeForXML());
                        }
                        else if(arguments[a + 1] instanceof Date)
                        {
                            an.setAttribute("Value", arguments[a + 1].toTremolFpString());
                        }
                        else if (arguments[a + 1] instanceof Uint8Array)
                        {
                            an.setAttribute("Value", arguments[a + 1].toBase64string());
                        }
                        else
                        {
                            an.setAttribute("Value", arguments[a + 1]);
                        }
                        as.appendChild(an);
                    }
                }
                var response = await sendReq("POST", url, xml); */

                var x = '<Command Name="' + commandName + '">';
                if (arguments.length > 1) {
                    x += "<Args>";
                    for (var a = 1; a < arguments.length; a += 2) {
                        if (typeof arguments[a + 1] === "string") {
                            x += '<Arg Name="' + arguments[a] + '" Value="' + arguments[a + 1].escapeForXML() + '" />';
                        }
                        else if (arguments[a + 1] instanceof Date) {
                            x += '<Arg Name="' + arguments[a] + '" Value="' + arguments[a + 1].toTremolFpString() + '" />';
                        }
                        else if (arguments[a + 1] instanceof Uint8Array) {
                            x += '<Arg Name="' + arguments[a] + '" Value="' + arguments[a + 1].toBase64string() + '" />';
                        }
                        else if (typeof arguments[a] === "undefined" || typeof arguments[a + 1] === "undefined" || arguments[a] == null || arguments[a + 1] == null) {
                            continue;
                        }
                        else {
                            x += '<Arg Name="' + arguments[a] + '" Value="' + String(arguments[a + 1]).escapeForXML() + '" />';
                        }
                    }
                    x += "</Args>";
                }
                x += "</Command>";
                var response = await sendReq("POST", url, x);
                return analyzeResponse(response);
            }
            catch (ex) {
                if (ex instanceof Tremol.ServerError) {
                    throw ex;
                }
                else {
                    throw new Tremol.ServerError(ex.message, Tremol.ServerErrorType.ServerErr);
                }
            }
            finally {
                w = false;
            }
        };

        /**
         * Gets ZfpLab server settings 
         * @returns {Tremol.FP.ServerSettings}
         */
        this.ServerGetSettings = async function () {
            return { ipaddress: ip, tcpport: port };
        };

        /**
         * @param {string} ipaddress Sets IP address
         * @param {number} tcpport Sets TCP port
         */
        this.ServerSetSettings = async function (ipaddress, tcpport) {
            ip = ipaddress;
            port = tcpport;
            url = ip;
            if (url.indexOf("//") === -1 && url.indexOf("http") === -1 && url.indexOf("https") === -1) {
                url = "//" + url;
            }
            if (port && port > 0) {
                url += (":" + port);
            }
            if (url.charAt(url.length - 1) !== "/") {
                url += "/";
            }
        };

        /**
         * Find device connected on serial port or USB
         * @returns {Tremol.FP.DeviceSettings}
         */
        this.ServerFindDevice = async function () {
            try {
                var response = await sendReq("GET", url + "finddevice", null);
                if (response.getElementsByTagName("com")[0].firstChild) {
                    var comS = response.getElementsByTagName("com")[0].firstChild.nodeValue; //.data
                    var baudS = Number(response.getElementsByTagName("baud")[0].firstChild.nodeValue);
                    var fps = { serialPort: comS, baudRate: baudS, isWorkingOnTcp: false };
                    return fps;
                }
                return null;
            }
            finally {
                w = false;
            }
        }

        /**
         * Gets the device settings
         * @returns {Tremol.FP.DeviceSettings}
         */
        this.ServerGetDeviceSettings = async function () {
            try {
                var response = await sendReq("GET", url + "settings", null);
                var isTcp = Boolean(response.getElementsByTagName("tcp")[0].firstChild.nodeValue);
                var comS = "";
                var nodeCom = response.getElementsByTagName("com")[0].firstChild;
                if (nodeCom) comS = nodeCom.nodeValue; //.data
                var baudS = Number(response.getElementsByTagName("baud")[0].firstChild.nodeValue);
                var ipS = response.getElementsByTagName("ip")[0].firstChild.nodeValue;
                var portS = Number(response.getElementsByTagName("port")[0].firstChild.nodeValue);
                var passS = response.getElementsByTagName("password")[0].firstChild.nodeValue;
                var portOpen = Boolean(response.getElementsByTagName("keepPortOpen")[0].firstChild.nodeValue);
                var df = response.getElementsByTagName("defVer");
                var servVerStr = "0.0.0.0";
                var servVer = response.getElementsByTagName("servVer");
                if (servVer) {
                    servVerStr = servVer[0].firstChild.nodeValue;
                }

                if (this.prototype.timeStamp && df.length > 0) {
                    ok = (this.prototype.timeStamp === Number(df[0].firstChild.nodeValue));
                }
                var fps = { isWorkingOnTcp: isTcp, ipaddress: ipS, tcpPort: portS, password: passS, serialPort: comS, baudRate: baudS, keepPortOpen: portOpen, serverVersion: servVerStr };

                return fps;
            }
            finally {
                w = false;
            }
        };

        this.ServerSendDefs = async function (defs) {
            w = true;
            try {
                if (!defsSent) {
                    await sendReq("POST", url, defs);
                    defsSent = true;
                }
            }
            finally {
                w = false;
            }
        };


        /**
         * Sets Device Bluetooth communication settings if ZFPLabServer is running on Android device.
         * @throws {Error}
         * @param {string} deviceFriendlyName Bluetooth Device friendly name (ZK900001)
         */
        this.ServerSetAndroidBluetoothDeviceSettings = async function (deviceFriendlyName) {
            try {
                if (!Tremol.FP.IsOnAndroid()) {
                    throw new Tremol.ServerError("This connection type is used only if ZFPLabServer is running on Android device", Tremol.ServerErrorType.ClientArgValueWrongFormat);
                }
                var response = await sendReq("GET", url + "settings(com=" + deviceFriendlyName + ",tcp=0)", null);
                var df = response.getElementsByTagName("defVer");
                if (this.prototype.timeStamp && df.length > 0) {
                    ok = (this.prototype.timeStamp === Number(df[0].firstChild.nodeValue));
                }
            }
            finally {
                w = false;
            }
        };

        /**
         * Sets Device serial port communication settings
         * This method is also used to set Bluetooth connection if ZFPLabServer is running on Android device.
         * @throws {Error}
         * @param {string} serialPort The name of the serial port (example: COM1).
         * @param {number} baudRate Baud rate (9600, 19200, 38400, 57600, 115200).
         * @param {boolean} keepPortOpen Keeps serial port open. For Bluetooth connection - not used.
         */
        this.ServerSetDeviceSerialSettings = async function (serialPort, baudRate, keepPortOpen, noPing, timeout) {
            try {
                var response = await sendReq("GET", url + "settings(com=" + serialPort + ",baud=" + baudRate + ",keepPortOpen=" + (keepPortOpen ? "1" : "0") + (noPing ? ',noping=1' : ',noping=0') + (timeout ? (",timeout=" + timeout) : "") + ",tcp=0)", null);
                var df = response.getElementsByTagName("defVer");
                if (this.prototype.timeStamp && df.length > 0) {
                    ok = (this.prototype.timeStamp === Number(df[0].firstChild.nodeValue));
                }
            }
            finally {
                w = false;
            }
        };

        /**
         * Sets Device LAN/WIFI communication settings
         * @throws {Error}
         * @param {string} ipaddress IP address
         * @param {number} tcpport TCP port
         * @param {string=} password ZFP password
         */
        this.ServerSetDeviceTcpSettings = async function (ipaddress, tcpport, password) {
            try {
                var response = await sendReq("GET", url + "settings(ip=" + ipaddress + ",port=" + tcpport + (password ? (",password=" + password) : "") + ",tcp=1)", null);
                var df = response.getElementsByTagName("defVer");
                if (this.prototype.timeStamp && df.length > 0) {
                    ok = (this.prototype.timeStamp === Number(df[0].firstChild.nodeValue));
                }
            }
            finally {
                w = false;
            }
        };

        /**
         * Gets ZfpLab server connected clients
         * @throws {Error}
         * @return {Tremol.FP.ServerClient[]}  Connected clients
         */
        this.ServerGetClients = async function () {
            try {
                var response = await sendReq("GET", url + "clients", null);
                var clientNodes = response.getElementsByTagName("Client");
                var clients = [];
                for (var c = 0; c < clientNodes.length; c++) {
                    var client = {
                        id: response.getElementsByTagName("Id")[c].firstChild.nodeValue,
                        ipaddress: response.getElementsByTagName("ip")[c].firstChild.nodeValue,
                        isConnected: (response.getElementsByTagName("PortIsOpen")[c].firstChild.nodeValue === "1")
                    };
                    clients.push(client);
                }
                return clients;
            }
            finally {
                w = false;
            }
        };

        /**
         * Removes client from the server
         * @param {string} ip IP address of the client
         * @throws {Error}
         */
        this.ServerRemoveClient = async function (ip) {
            try {
                await sendReq("GET", url + "clientremove(ip=" + ip + ")", null);
            }
            finally {
                w = false;
            }
        };

        /**
         * Closes the connection of the current client
         * @throws {Error}
         */
        this.ServerCloseDeviceConnection = async function () {
            try {
                await sendReq("GET", url + "clientremove(who=me)", null);
            }
            finally {
                w = false;
            }
        };

        /**
         * Removes all clients from the server
         * @throws {Error}
         */
        this.ServerRemoveAllClients = async function () {
            try {
                await sendReq("GET", url + "clientremove(who=all)", null);
            }
            finally {
                w = false;
            }
        };

        /**
        * Enables or disables ZfpLab server log
        * @throws {Error}
        * @param {boolean} enable enable the log
        */
        this.ServerSetLog = async function (enable) {
            try {
                await sendReq("GET", url + "log(on=" + (enable ? "1" : "0") + ")", null);
            }
            finally {
                w = false;
            }
        };
    };


Tremol.FP.IsOnAndroid = function () {
    return (navigator.userAgent.toLowerCase().indexOf("android") > -1);
}

/** 
 * @typedef {Tremol.ServerErrorType} Tremol.ServerErrorType
 * @enum
 * @readonly
 */
Tremol.ServerErrorType = {
    /** @memberof Tremol.ServerErrorType */
    OK: 0,
    /** The current library version and the fiscal device firmware is not matching */
    ServMismatchBetweenDefinitionAndFPResult: 9,
    ServDefMissing: 10,
    ServArgDefMissing: 11,
    ServCreateCmdString: 12,
    ServUndefined: 19,
    /** When the server can not connect to the fiscal device */
    ServSockConnectionFailed: 30,
    /** Wrong device ТCP password */
    ServTCPAuth: 31,
    ServWrongTcpConnSettings: 32,
    ServWrongSerialPortConnSettings: 33,
    /** Proccessing of other clients command is taking too long */
    ServWaitOtherClientCmdProcessingTimeOut: 34,
    ServDisconnectOtherClientErr: 35,
    FPException: 40,
    ClientArgDefMissing: 50,
    ClientAttrDefMissing: 51,
    ClientArgValueWrongFormat: 52,
    ClientSettingsNotInitialized: 53,
    ClientInvalidGetFormat: 62,
    ClientInvalidPostFormat: 63,
    ServerAddressNotSet: 100,
    /** Specify server ServerAddress property */
    ServerConnectionError: 101,
    /** Connection from this app to the server is not established */
    ServerResponseMissing: 102,
    ServerResponseError: 103,
    /** The current library version and server definitions version do not match */
    ServerDefsMismatch: 104,
    ClientXMLCanNotParse: 105,
    PaymentNotSupported: 201,
    ServerErr: 1000
};
Object.freeze(Tremol.ServerErrorType);

/**
 * @constructor
 * @class FPError
 * @classdesc Error thrown from Tremol.FP library
 * @param {string} message
 * @param {Tremol.ServerErrorType} type
 * @param {number=} ste1
 * @param {number=} ste2
 * @param {fpliberror=} ste2
 */
Tremol.ServerError = function (message, type, ste1, ste2, fpliberror) {
    if (!(this instanceof Tremol.ServerError)) {
        return new Tremol.ServerError(message, type, ste1, ste2, fpliberror);
    }
    this.type = type;
    this.name = "Tremol.ZFPLabError";
    this.message = (message || "");
    this.ste1;
    this.ste2;
    if (ste1 !== undefined && ste1 !== null) {
        this.ste1 = ste1;
    }
    if (ste2 !== undefined && ste2 !== null) {
        this.ste2 = ste2;
    }
    if (fpliberror !== undefined && fpliberror !== null) {
        this.fpLibError = fpliberror;
    }
    this.isFpException = (this.type === Tremol.ServerErrorType.FPException);
};
Tremol.ServerError.prototype = Error;

Date.TremolFpFormat = "dd-MM-yyyy HH:mm:ss";

Date.prototype.toTremolFpString = function () {
    var d = this.getDate().lpad(2);
    var M = (this.getMonth() + 1).lpad(2);
    var y = this.getFullYear().lpad(4);
    var h = this.getHours().lpad(2);
    var m = this.getMinutes().lpad(2);
    var s = this.getSeconds().lpad(2);
    return d + "-" + M + "-" + y + " " + h + ":" + m + ":" + s;
};

Date.prototype.toStringWithFormat = function (format) {
    var f = format;
    var d = this.getDate();
    var M = (this.getMonth() + 1);
    var y = this.getFullYear();
    var h = this.getHours();
    var m = this.getMinutes();
    var s = this.getSeconds();
    f = f.replace("dd", d.lpad(2));
    f = f.replace("d", d); f
    f = f.replace("MM", M.lpad(2));
    f = f.replace("M", M);
    f = f.replace("yyyy", y.lpad(4));
    f = f.replace("yy", (y - 2000).lpad(2));
    f = f.replace("hh", h.lpad(2));
    f = f.replace("mm", m.lpad(2));
    f = f.replace("m", m);
    f = f.replace("ss", s.lpad(2));
    f = f.replace("s", s);
    return f;
};

Number.prototype.lpad = function (size) {
    var s = String(this);
    while (s.length < (size || 2)) { s = "0" + s; }
    return s;
};

String.prototype.parseDateWithFormat = function (format) {
    var p = this;
    var f = format;
    var y = 0;
    var M = 0;
    var d = 0;
    var h = 0;
    var m = 0;
    var s = 0;
    var yIx = f.indexOf("yyyy");
    var MIx = f.indexOf("MM");
    var dIx = f.indexOf("dd");
    var hIx = f.indexOf("HH");
    var mIx = f.indexOf("mm");
    var sIx = f.indexOf("ss");
    if (yIx !== -1) {
        y = parseInt(p.substring(yIx, yIx + 4));
    }
    else {
        yIx = f.indexOf("yy");
        if (yIx !== -1) {
            y = parseInt(p.substring(yIx, yIx + 2));
        }
    }
    if (MIx !== -1) {
        M = parseInt(p.substring(MIx, MIx + 2)) - 1;
    }
    if (dIx !== -1) {
        d = parseInt(p.substring(dIx, dIx + 2));
    }
    if (hIx !== -1) {
        h = parseInt(p.substring(hIx, hIx + 2));
    }
    if (mIx !== -1) {
        m = parseInt(p.substring(mIx, mIx + 2));
    }
    if (sIx !== -1) {
        s = parseInt(p.substring(sIx, sIx + 2));
    }
    return new Date(y, M, d, h, m, s);
};

/**
 * This method replaces all matches in the string
 * @this {string}
 * @param {string} search the string which shoould be replaced
 * @param {string} replacement the string wich should be put for replacement
 */
String.prototype.replaceAll = function (search, replacement) {
    return this.replace(new RegExp(search.replace(/([.*+?^=!:${}()|][/\\])/g, "\\$1"), 'g'), replacement);
};

String.prototype.escapeForXML = function () {
    var ss = this.toString();
    ss = ss.replaceAll("&", '&amp;')
        .replaceAll("<", '&lt;')
        .replaceAll(">", '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&apos;')
        .replaceAll("\n", '&#10;')
        .replaceAll("\r", '&#13;');
    return ss;
};

String.prototype.base64stringToArrayBuffer = function () {
    var binary_string = window.atob(this.toString());
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes;
};


String.prototype.stringToUint8ArrayBuffer = function () {
    var buf = new ArrayBuffer(this.length);
    var len = this.length;
    var bytes = new Uint8Array(buf);
    for (var i = 0; i < len; i++) {
        bytes[i] = this.charCodeAt(i);
    }
    return bytes;
}



Uint8Array.prototype.toBase64string = function () {
    var arr = this;
    var binary = '';
    for (var i = 0; i < arr.byteLength; i++) {
        binary += String.fromCharCode(arr[i]);
    }
    return window.btoa(binary);
};

Uint8Array.prototype.toUnicodeString = function () {
    var arr = this;
    var res = ""
    for (var i = 0; i < arr.byteLength; i++) {
        res += String.fromCharCode(arr[i]);
    }
    return res;
};

String.prototype.toBase64string = function () {
    return window.btoa(this)
}

var u2w1251Buff = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, 10: 10, 11: 11, 12: 12, 13: 13, 14: 14, 15: 15, 16: 16, 17: 17, 18: 18, 19: 19, 20: 20, 21: 21, 22: 22, 23: 23, 24: 24, 25: 25, 26: 26, 27: 27, 28: 28, 29: 29, 30: 30, 31: 31, 32: 32, 33: 33, 34: 34, 35: 35, 36: 36, 37: 37, 38: 38, 39: 39, 40: 40, 41: 41, 42: 42, 43: 43, 44: 44, 45: 45, 46: 46, 47: 47, 48: 48, 49: 49, 50: 50, 51: 51, 52: 52, 53: 53, 54: 54, 55: 55, 56: 56, 57: 57, 58: 58, 59: 59, 60: 60, 61: 61, 62: 62, 63: 63, 64: 64, 65: 65, 66: 66, 67: 67, 68: 68, 69: 69, 70: 70, 71: 71, 72: 72, 73: 73, 74: 74, 75: 75, 76: 76, 77: 77, 78: 78, 79: 79, 80: 80, 81: 81, 82: 82, 83: 83, 84: 84, 85: 85, 86: 86, 87: 87, 88: 88, 89: 89, 90: 90, 91: 91, 92: 92, 93: 93, 94: 94, 95: 95, 96: 96, 97: 97, 98: 98, 99: 99, 100: 100, 101: 101, 102: 102, 103: 103, 104: 104, 105: 105, 106: 106, 107: 107, 108: 108, 109: 109, 110: 110, 111: 111, 112: 112, 113: 113, 114: 114, 115: 115, 116: 116, 117: 117, 118: 118, 119: 119, 120: 120, 121: 121, 122: 122, 123: 123, 124: 124, 125: 125, 126: 126, 127: 127, 160: 160, 164: 164, 166: 166, 167: 167, 169: 169, 171: 171, 172: 172, 173: 173, 174: 174, 176: 176, 177: 177, 181: 181, 182: 182, 183: 183, 187: 187, 1025: 168, 1026: 128, 1027: 129, 1028: 170, 1029: 189, 1030: 178, 1031: 175, 1032: 163, 1033: 138, 1034: 140, 1035: 142, 1036: 141, 1038: 161, 1039: 143, 1040: 192, 1041: 193, 1042: 194, 1043: 195, 1044: 196, 1045: 197, 1046: 198, 1047: 199, 1048: 200, 1049: 201, 1050: 202, 1051: 203, 1052: 204, 1053: 205, 1054: 206, 1055: 207, 1056: 208, 1057: 209, 1058: 210, 1059: 211, 1060: 212, 1061: 213, 1062: 214, 1063: 215, 1064: 216, 1065: 217, 1066: 218, 1067: 219, 1068: 220, 1069: 221, 1070: 222, 1071: 223, 1072: 224, 1073: 225, 1074: 226, 1075: 227, 1076: 228, 1077: 229, 1078: 230, 1079: 231, 1080: 232, 1081: 233, 1082: 234, 1083: 235, 1084: 236, 1085: 237, 1086: 238, 1087: 239, 1088: 240, 1089: 241, 1090: 242, 1091: 243, 1092: 244, 1093: 245, 1094: 246, 1095: 247, 1096: 248, 1097: 249, 1098: 250, 1099: 251, 1100: 252, 1101: 253, 1102: 254, 1103: 255, 1105: 184, 1106: 144, 1107: 131, 1108: 186, 1109: 190, 1110: 179, 1111: 191, 1112: 188, 1113: 154, 1114: 156, 1115: 158, 1116: 157, 1118: 162, 1119: 159, 1168: 165, 1169: 180, 8211: 150, 8212: 151, 8216: 145, 8217: 146, 8218: 130, 8220: 147, 8221: 148, 8222: 132, 8224: 134, 8225: 135, 8226: 149, 8230: 133, 8240: 137, 8249: 139, 8250: 155, 8364: 136, 8470: 185, 8482: 153 };
var w2uBuff = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, 10: 10, 11: 11, 12: 12, 13: 13, 14: 14, 15: 15, 16: 16, 17: 17, 18: 18, 19: 19, 20: 20, 21: 21, 22: 22, 23: 23, 24: 24, 25: 25, 26: 26, 27: 27, 28: 28, 29: 29, 30: 30, 31: 31, 32: 32, 33: 33, 34: 34, 35: 35, 36: 36, 37: 37, 38: 38, 39: 39, 40: 40, 41: 41, 42: 42, 43: 43, 44: 44, 45: 45, 46: 46, 47: 47, 48: 48, 49: 49, 50: 50, 51: 51, 52: 52, 53: 53, 54: 54, 55: 55, 56: 56, 57: 57, 58: 58, 59: 59, 60: 60, 61: 61, 62: 62, 63: 63, 64: 64, 65: 65, 66: 66, 67: 67, 68: 68, 69: 69, 70: 70, 71: 71, 72: 72, 73: 73, 74: 74, 75: 75, 76: 76, 77: 77, 78: 78, 79: 79, 80: 80, 81: 81, 82: 82, 83: 83, 84: 84, 85: 85, 86: 86, 87: 87, 88: 88, 89: 89, 90: 90, 91: 91, 92: 92, 93: 93, 94: 94, 95: 95, 96: 96, 97: 97, 98: 98, 99: 99, 100: 100, 101: 101, 102: 102, 103: 103, 104: 104, 105: 105, 106: 106, 107: 107, 108: 108, 109: 109, 110: 110, 111: 111, 112: 112, 113: 113, 114: 114, 115: 115, 116: 116, 117: 117, 118: 118, 119: 119, 120: 120, 121: 121, 122: 122, 123: 123, 124: 124, 125: 125, 126: 126, 127: 127, 129: 1027, 135: 8225, 198: 1046, 132: 8222, 199: 1047, 165: 1168, 200: 1048, 154: 1113, 201: 1049, 197: 1045, 202: 1050, 170: 1028, 160: 160, 192: 1040, 203: 1051, 164: 164, 166: 166, 167: 167, 169: 169, 171: 171, 172: 172, 173: 173, 174: 174, 205: 1053, 176: 176, 177: 177, 156: 1114, 181: 181, 182: 182, 183: 183, 148: 8221, 187: 187, 189: 1029, 208: 1056, 209: 1057, 210: 1058, 136: 8364, 188: 1112, 158: 1115, 211: 1059, 212: 1060, 178: 1030, 213: 1061, 214: 1062, 215: 1063, 157: 1116, 216: 1064, 217: 1065, 175: 1031, 218: 1066, 219: 1067, 220: 1068, 221: 1069, 222: 1070, 163: 1032, 149: 8226, 223: 1071, 224: 1072, 153: 8482, 225: 1073, 137: 8240, 162: 1118, 226: 1074, 179: 1110, 133: 8230, 227: 1075, 138: 1033, 228: 1076, 229: 1077, 150: 8211, 230: 1078, 159: 1119, 231: 1079, 194: 1042, 232: 1080, 140: 1034, 168: 1025, 233: 1081, 234: 1082, 151: 8212, 235: 1083, 180: 1169, 236: 1084, 204: 1052, 237: 1085, 142: 1035, 238: 1086, 239: 1087, 240: 1088, 241: 1089, 242: 1090, 141: 1036, 193: 1041, 243: 1091, 244: 1092, 134: 8224, 245: 1093, 185: 8470, 246: 1094, 206: 1054, 247: 1095, 248: 1096, 139: 8249, 249: 1097, 250: 1098, 196: 1044, 251: 1099, 191: 1111, 207: 1055, 252: 1100, 161: 1038, 147: 8220, 253: 1101, 155: 8250, 254: 1102, 145: 8216, 255: 1103, 195: 1043, 184: 1105, 143: 1039, 128: 1026, 144: 1106, 130: 8218, 131: 1107, 146: 8217, 186: 1108, 190: 1109 };
var u2w866Buff = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, 10: 10, 11: 11, 12: 12, 13: 13, 14: 14, 15: 15, 16: 16, 17: 17, 18: 18, 19: 19, 20: 20, 21: 21, 22: 22, 23: 23, 24: 24, 25: 25, 26: 26, 27: 27, 28: 28, 29: 29, 30: 30, 31: 31, 32: 32, 33: 33, 34: 34, 35: 35, 36: 36, 37: 37, 38: 38, 39: 39, 40: 40, 41: 41, 42: 42, 43: 43, 44: 44, 45: 45, 46: 46, 47: 47, 48: 48, 49: 49, 50: 50, 51: 51, 52: 52, 53: 53, 54: 54, 55: 55, 56: 56, 57: 57, 58: 58, 59: 59, 60: 60, 61: 61, 62: 62, 63: 63, 64: 64, 65: 65, 66: 66, 67: 67, 68: 68, 69: 69, 70: 70, 71: 71, 72: 72, 73: 73, 74: 74, 75: 75, 76: 76, 77: 77, 78: 78, 79: 79, 80: 80, 81: 81, 82: 82, 83: 83, 84: 84, 85: 85, 86: 86, 87: 87, 88: 88, 89: 89, 90: 90, 91: 91, 92: 92, 93: 93, 94: 94, 95: 95, 96: 96, 97: 97, 98: 98, 99: 99, 100: 100, 101: 101, 102: 102, 103: 103, 104: 104, 105: 105, 106: 106, 107: 107, 108: 108, 109: 109, 110: 110, 111: 111, 112: 112, 113: 113, 114: 114, 115: 115, 116: 116, 117: 117, 118: 118, 119: 119, 120: 120, 121: 121, 122: 122, 123: 123, 124: 124, 125: 125, 126: 126, 127: 127, 164: 253, 176: 248, 183: 250, 1025: 240, 1028: 242, 1031: 244, 1038: 246, 1040: 128, 1041: 129, 1042: 130, 1043: 131, 1044: 132, 1045: 133, 1046: 134, 1047: 135, 1048: 136, 1049: 137, 1050: 138, 1051: 139, 1052: 140, 1053: 141, 1054: 142, 1055: 143, 1056: 144, 1057: 145, 1058: 146, 1059: 147, 1060: 148, 1061: 149, 1062: 150, 1063: 151, 1064: 152, 1065: 153, 1066: 154, 1067: 155, 1068: 156, 1069: 157, 1070: 158, 1071: 159, 1072: 160, 1073: 161, 1074: 162, 1075: 163, 1076: 164, 1077: 165, 1078: 166, 1079: 167, 1080: 168, 1081: 169, 1082: 170, 1083: 171, 1084: 172, 1085: 173, 1086: 174, 1087: 175, 1088: 224, 1089: 225, 1090: 226, 1091: 227, 1092: 228, 1093: 229, 1094: 230, 1095: 231, 1096: 232, 1097: 233, 1098: 234, 1099: 235, 1100: 236, 1101: 237, 1102: 238, 1103: 239, 1105: 241, 1108: 243, 1111: 245, 1118: 247, 8239: 255, 8470: 252, 8729: 249, 8730: 251, 9472: 196, 9474: 179, 9484: 218, 9488: 191, 9492: 192, 9496: 217, 9500: 195, 9508: 180, 9516: 194, 9524: 193, 9532: 197, 9552: 205, 9553: 186, 9554: 213, 9555: 214, 9556: 201, 9557: 184, 9558: 183, 9559: 187, 9560: 212, 9561: 211, 9562: 200, 9563: 190, 9564: 189, 9565: 188, 9566: 198, 9567: 199, 9568: 204, 9569: 181, 9570: 182, 9571: 185, 9572: 209, 9573: 210, 9574: 203, 9575: 207, 9576: 208, 9577: 202, 9578: 216, 9579: 215, 9580: 206, 9600: 223, 9604: 220, 9608: 219, 9612: 221, 9616: 222, 9617: 176, 9618: 177, 9619: 178, 9632: 254 };
var w866u2Buff = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, 10: 10, 11: 11, 12: 12, 13: 13, 14: 14, 15: 15, 16: 16, 17: 17, 18: 18, 19: 19, 20: 20, 21: 21, 22: 22, 23: 23, 24: 24, 25: 25, 26: 26, 27: 27, 28: 28, 29: 29, 30: 30, 31: 31, 32: 32, 33: 33, 34: 34, 35: 35, 36: 36, 37: 37, 38: 38, 39: 39, 40: 40, 41: 41, 42: 42, 43: 43, 44: 44, 45: 45, 46: 46, 47: 47, 48: 48, 49: 49, 50: 50, 51: 51, 52: 52, 53: 53, 54: 54, 55: 55, 56: 56, 57: 57, 58: 58, 59: 59, 60: 60, 61: 61, 62: 62, 63: 63, 64: 64, 65: 65, 66: 66, 67: 67, 68: 68, 69: 69, 70: 70, 71: 71, 72: 72, 73: 73, 74: 74, 75: 75, 76: 76, 77: 77, 78: 78, 79: 79, 80: 80, 81: 81, 82: 82, 83: 83, 84: 84, 85: 85, 86: 86, 87: 87, 88: 88, 89: 89, 90: 90, 91: 91, 92: 92, 93: 93, 94: 94, 95: 95, 96: 96, 97: 97, 98: 98, 99: 99, 100: 100, 101: 101, 102: 102, 103: 103, 104: 104, 105: 105, 106: 106, 107: 107, 108: 108, 109: 109, 110: 110, 111: 111, 112: 112, 113: 113, 114: 114, 115: 115, 116: 116, 117: 117, 118: 118, 119: 119, 120: 120, 121: 121, 122: 122, 123: 123, 124: 124, 125: 125, 126: 126, 127: 127, 128: 1040, 129: 1041, 130: 1042, 131: 1043, 132: 1044, 133: 1045, 134: 1046, 135: 1047, 136: 1048, 137: 1049, 138: 1050, 139: 1051, 140: 1052, 141: 1053, 142: 1054, 143: 1055, 144: 1056, 145: 1057, 146: 1058, 147: 1059, 148: 1060, 149: 1061, 150: 1062, 151: 1063, 152: 1064, 153: 1065, 154: 1066, 155: 1067, 156: 1068, 157: 1069, 158: 1070, 159: 1071, 160: 1072, 161: 1073, 162: 1074, 163: 1075, 164: 1076, 165: 1077, 166: 1078, 167: 1079, 168: 1080, 169: 1081, 170: 1082, 171: 1083, 172: 1084, 173: 1085, 174: 1086, 175: 1087, 176: 9617, 177: 9618, 178: 9619, 179: 9474, 180: 9508, 181: 9569, 182: 9570, 183: 9558, 184: 9557, 185: 9571, 186: 9553, 187: 9559, 188: 9565, 189: 9564, 190: 9563, 191: 9488, 192: 9492, 193: 9524, 194: 9516, 195: 9500, 196: 9472, 197: 9532, 198: 9566, 199: 9567, 200: 9562, 201: 9556, 202: 9577, 203: 9574, 204: 9568, 205: 9552, 206: 9580, 207: 9575, 208: 9576, 209: 9572, 210: 9573, 211: 9561, 212: 9560, 213: 9554, 214: 9555, 215: 9579, 216: 9578, 217: 9496, 218: 9484, 219: 9608, 220: 9604, 221: 9612, 222: 9616, 223: 9600, 224: 1088, 225: 1089, 226: 1090, 227: 1091, 228: 1092, 229: 1093, 230: 1094, 231: 1095, 232: 1096, 233: 1097, 234: 1098, 235: 1099, 236: 1100, 237: 1101, 238: 1102, 239: 1103, 240: 1025, 241: 1105, 242: 1028, 243: 1108, 244: 1031, 245: 1111, 246: 1038, 247: 1118, 248: 176, 249: 8729, 250: 183, 251: 8730, 252: 8470, 253: 164, 254: 9632, 255: 8239 };

// function objectFlip(obj) {
//     return Object.keys(obj).reduce((ret, key) => {
//         ret[Number(obj[key])] = key;
//         return ret;
//     }, {});
// }
// console.log(JSON.stringify(objectFlip(w866u2Buff)));

String.prototype.win1251toUTF = function () {
    var s = this;
    var L = [];
    for (var i = 0; i < s.length; i++) {
        var ord = s.charCodeAt(i);
        if (!(ord in w2uBuff))
            throw "Символ със стойност " + s.charAt(i) + " не е валиден windows-1251!"
        L.push(String.fromCharCode(w2uBuff[ord]));
    }
    return L.join('');
}

String.prototype.utfToWin1251 = function () {
    var s = this;
    var L = [];
    for (var i = 0; i < s.length; i++) {
        var ord = s.charCodeAt(i);
        if (!(ord in u2w1251Buff))
            throw "Символ със стойност " + s.charAt(i) + " не е валиден UTF8!"
        L.push(String.fromCharCode(u2w1251Buff[ord]));
    }
    return L.join('');
}

String.prototype.win866toUTF = function () {
    var s = this;
    var L = [];
    for (var i = 0; i < s.length; i++) {
        var ord = s.charCodeAt(i);
        if (!(ord in w866u2Buff))
            throw "Символ със стойност " + s.charAt(i) + " не е валиден windows-866!"
        L.push(String.fromCharCode(w866u2Buff[ord]));
    }
    return L.join('');
}


String.prototype.utfToWin866 = function () {
    var s = this;
    var L = [];
    for (var i = 0; i < s.length; i++) {
        var ord = s.charCodeAt(i);
        if (!(ord in u2w866Buff))
            throw "Символ със стойност " + s.charAt(i) + " не е валиден UTF8!"
        L.push(String.fromCharCode(u2w866Buff[ord]));
    }
    return L.join('');
}

/**
* @typedef {Object} Tremol.FP.ServerSettings
* @property {string} ipaddress IP address
* @property {number} tcpport TCP port
*/

/**
* @typedef {Object} Tremol.FP.DeviceSettings
* @property {boolean} isWorkingOnTcp True if device is working on tcp
* @property {string} serialPort Serial port (example: COM1). If ZFPLabServer is running on Android device - Device friendly name (ZK999999)
* @property {number} baudRate Baud rate (9600, 19200, 38400, 57600, 115200)
* @property {boolean} keepPortOpen Keeps the port opened
* @property {string} ipaddress IP address
* @property {number} tcpPort TCP port
* @property {string?} password ZFP wifi password
*/
/**
* @typedef {Object} Tremol.FP.ServerClient
* @property {string} id Client id
* @property {string} ipaddress IP address
* @property {boolean} isConnected The client is connected to device
*/
module.exports = Tremol